var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessDenied(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "249px",
    height: "217px",
    viewBox: "0 0 249 217",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "access-denied-copy-2",
    transform: "translate(-596.000000, -252.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(485.000000, 236.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(111.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Polygon",
    fill: "#4A4A4A",
    transform: "translate(124.500000, 124.500000) rotate(90.000000) translate(-124.500000, -124.500000) ",
    points: "124.5 0 232.320163 62.25 232.320163 186.75 124.5 249 16.6798372 186.75 16.6798372 62.25"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(49.000000, 52.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.7726976,90.9551861 L79.7726976,90.9571553 L79.7726976,104.015079 C79.7726976,106.090641 78.0992815,107.772358 76.0339647,107.772358 L67.8922273,107.772358 C65.8269105,107.772358 64.1515349,106.090641 64.1515349,104.015079 L64.1515349,90.9571553 C64.1515349,90.7031254 64.178968,90.4550032 64.2259961,90.2147579 C61.2259961,87.7867049 59.3037231,84.0648719 59.3037231,79.8920865 C59.3037231,72.5646046 65.2116264,66.6273947 72.5029393,66.6273947 C79.7903331,66.6273947 85.6982364,72.5646046 85.6982364,79.8920865 C85.6982364,84.5138549 83.3409536,88.5803021 79.7726976,90.9551861 M112.449379,52 L32.55258,52 C30.5911169,52 29,53.5990098 29,55.5702028 L29,118.427828 C29,120.40099 30.5911169,122 32.55258,122 L112.449379,122 C114.410843,122 116,120.40099 116,118.427828 L116,55.5702028 C116,53.5990098 114.410843,52 112.449379,52",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,47 L86.8769254,47 L86.8769254,33.0055617 C86.8769254,24.8009754 80.2004612,18.1274921 72.0009839,18.1274921 C63.7956034,18.1274921 57.1250423,24.8009754 57.1250423,33.0055617 L57.1250423,47 L40,47 L40,33.0055617 C40,15.358518 54.3544965,1 72.0009839,1 C89.6435357,1 104,15.358518 104,33.0055617 L104,47 Z",
    id: "Fill-3"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessDenied);
export default __webpack_public_path__ + "static/media/access-denied.0c94d67498ee8c2a458943a6fd0fe374.svg";
export { ForwardRef as ReactComponent };